import {GetEntries} from "js-vextensions";
import {observer_mgl} from "mobx-graphlink";
import React from "react";
import {Button, CheckBox, Column, Row, Select, Text} from "react-vcomponents";
import {ShowMessageBox} from "react-vmessagebox";
import {RunInAction_Set} from "web-vcore";
import {MapObject} from "../../../../../Server/DB/mapObjects/@MapObject.js";
import {ObjPath} from "../../../../../Server/DB/mapObjects/@MapObject/ObjPath.js";
import {PathTab} from "../../../../../Store/main/maps/@MapState.js";
import {CloneSafe} from "../../../../../Utils/General/Serialization.js";
import {PropertiesUI_SharedProps} from "../../PropertiesUI.js";
import {PathEditorTab_Fill} from "./PathEditorTabs/Fill.js";
import {PathEditorTab_General} from "./PathEditorTabs/General.js";
import {PathEditorTab_Material} from "./PathEditorTabs/Material.js";
import {PathEditorTab_Points} from "./PathEditorTabs/Points.js";
import {PathEditorTab_Scenery} from "./PathEditorTabs/Scenery.js";
import {PathEditorTab_Terrain} from "./PathEditorTabs/Terrain.js";
import {PathEditorTab_Transforms} from "./PathEditorTabs/Transforms.js";

export type PathEditorUI_SharedProps = Omit<PropertiesUI_SharedProps, "Change"> & {
	path: ObjPath;
	index: number;
	ChangeObj: (mutator: (obj: MapObject)=>any)=>any;
	Change: (mutator: (obj: ObjPath)=>any)=>any;
};

export const PathEditorUI = observer_mgl((props: {index: number} & PropertiesUI_SharedProps)=>{
	const {obj, mapState, Change: ChangeObj, index} = props;
	const uiState = mapState.propertiesPanel;
	const path = obj.paths[index];
	const Change = (mutator: (obj: ObjPath)=>any)=>{
		return ChangeObj(a=>mutator(a.paths[index]));
	};

	const sharedProps: PathEditorUI_SharedProps = {...props, path, index, ChangeObj, Change};
	return (
		<Column mt={5} style={{background: "rgba(255,255,255,.2)", padding: 5, borderRadius: 5}}>
			<Row>
				<Text style={{minWidth: 10}}>Path {index + 1}</Text>
				<Row ml="auto">
					<CheckBox text="Selected" value={path.selected ?? false} onChange={val=>{
						ChangeObj(a=>{
							a.paths = a.paths.map((pathInClone, i)=>{
								if (i == index) pathInClone.selected = val;
								else pathInClone.selected = false; // unselect others
								return pathInClone;
							});
						});
					}}/>
					<Button ml={5} mdIcon="content-copy" title="Clone" onClick={()=>{
						ChangeObj(a=>{
							const thisPath_new = CloneSafe(a.paths[index]);
							const thisPath_clone = CloneSafe(thisPath_new);
							a.paths[index] = thisPath_new;
							a.paths.Insert(index + 1, thisPath_clone);
							// set only the new clone as selected
							for (const path2 of a.paths) path2.selected = false;
							thisPath_clone.selected = true;
						});
					}}/>
					<Button ml={5} mdIcon="delete" onClick={()=>{
						ShowMessageBox({
							title: "Delete path?", cancelButton: true,
							message: "Are you sure you want to delete this path?",
							onOK: ()=>{
								ChangeObj(a=>a.paths.RemoveAt(index));
							},
						});
					}}/>
				</Row>
			</Row>
			<Row>
				<Select displayType="button bar" options={GetEntries(PathTab, "ui")}
					value={uiState.path_tab} onChange={val=>RunInAction_Set(()=>uiState.path_tab = val)}/>
			</Row>
			{uiState.path_tab == PathTab.general && <PathEditorTab_General {...sharedProps}/>}
			{uiState.path_tab == PathTab.points && <PathEditorTab_Points {...sharedProps}/>}
			{uiState.path_tab == PathTab.transforms && <PathEditorTab_Transforms {...sharedProps}/>}
			{uiState.path_tab == PathTab.fill && <PathEditorTab_Fill {...sharedProps}/>}
			{uiState.path_tab == PathTab.terrain && <PathEditorTab_Terrain {...sharedProps}/>}
			{uiState.path_tab == PathTab.material && <PathEditorTab_Material {...sharedProps}/>}
			{uiState.path_tab == PathTab.scenery && <PathEditorTab_Scenery {...sharedProps}/>}
		</Column>
	);
});